<!--cowork_wb 整合其中的mindmap 到Sharing本站，可響應HT協議-->
<template >
    <div>
        <MindMap :isTool="isTool" :isPlayground="isPlayground" />
    </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import MindMap from './MindMap.vue';
export default {
    name: "HTwbMind",
    components: {
        MindMap
    },
    setup() {
        const route = useRoute();
        const isTool = ref(false); // 判斷mindmap 是否為預編工具
        const isPlayground = ref(false); // 遊樂場模式（未登入體驗）

        onMounted(() => {
            const urlParams = new URLSearchParams(window.location.search);
            isTool.value = urlParams.get('isTool') === 'true';
            // /playground 路由 或 ?playground=true 均啟用遊樂場
            isPlayground.value = route.path === '/playground' || urlParams.get('playground') === 'true';
        });

        return {
            isTool,
            isPlayground,
        };
    },
}
</script>
<style lang="less">
    
</style>